/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
setTimeout(function() {
    theme.headerNav();
}, 500);
setTimeout(function() {
    theme.headerNav();
}, 800);
setTimeout(function() {
    theme.headerNav();
}, 1200);
setTimeout(function() {
    theme.headerNav();
}, 1500);
